import React from 'react';
import { Search } from 'lucide-react';
import Button from '../../common/Button/Button';

interface ModalEmptyStateProps {
  heading: string;
  body: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
  icon?: React.ReactNode;
  terminal?: boolean;
}

const ModalEmptyState: React.FC<ModalEmptyStateProps> = ({
  heading,
  body,
  ctaLabel,
  onCtaClick,
  icon,
  terminal = false,
}) => (
  <div className="flex flex-col items-center py-10 text-center" role="status" aria-live="polite">
    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gray-100 mb-3.5">
      {icon ?? <Search className="h-6 w-6 text-gray-400" aria-hidden />}
    </div>
    <p className="text-sm font-semibold text-gray-700 mb-1.5">{heading}</p>
    <p className="text-xs text-gray-400 max-w-[220px] leading-relaxed mb-5">{body}</p>
    {!terminal && ctaLabel && onCtaClick && (
      <Button onClick={onCtaClick} variant="primary">
        {ctaLabel}
      </Button>
    )}
  </div>
);

export default ModalEmptyState;
